import React from 'react';
import './style.scss';
import { IContentSection, ITableOfContentItem } from '../page-template';
import PageTemplate from '../page-template/component';
import HeaderImg from '../../../assets/images/travbusiness-template-pages/ef100dc7-5771-43e4-a1c9-d0269ecb5142.jpg'
import { useIntl } from 'react-intl';

const TravBusinessSolutionsTravelManagersPage: React.FC = () => {
  const intl = useIntl();
  const tocItems: ITableOfContentItem[] = [
    { id: 'centralized-booking-platform', title: intl.formatMessage({ id: 'travel-mgrs.centralized.booking.platform' }) },
    { id: 'policy-compliance-controls', title: intl.formatMessage({ id: 'travel-mgrs.policy.compliance.controls' }) },
    { id: '24/7-customer-support', title: intl.formatMessage({ id: 'travel-mgrs.24.7.customer.support' }) },
    { id: 'automated-expense-integration', title: intl.formatMessage({ id: 'travel-mgrs.automated.expense.integration' }) },
    { id: 'real-time-visibility', title: intl.formatMessage({ id: 'travel-mgrs.real.time.visibility' }) },
  ];

const sections: IContentSection[] = [
  {
    id: 'travel-mgrs.centralized-booking-platform',
    title: intl.formatMessage({ id: 'travel-mgrs.centralized.booking.platform' }),
    paragraphs: [
      intl.formatMessage({ id: 'travel-mgrs.centralized.booking.platform.p1' }),
      intl.formatMessage({ id: 'travel-mgrs.centralized.booking.platform.p2' }),
    ],
  },
  {
    id: 'travel-mgrs.policy-compliance-controls',
    title: intl.formatMessage({ id: 'travel-mgrs.policy.compliance.controls' }),
    paragraphs: [
      intl.formatMessage({ id: 'travel-mgrs.policy.compliance.controls.p1' }),
      intl.formatMessage({ id: 'travel-mgrs.policy.compliance.controls.p2' }),
    ],
  },
  {
    id: 'travel-mgrs.24-7-customer-support',
    title: intl.formatMessage({ id: 'travel-mgrs.24.7.customer.support' }),
    paragraphs: [
      intl.formatMessage({ id: 'travel-mgrs.24.7.customer.support.p1' }),
      intl.formatMessage({ id: 'travel-mgrs.24.7.customer.support.p2' }),
    ],
  },
  {
    id: 'travel-mgrs.automated-expense-integration',
    title: intl.formatMessage({ id: 'travel-mgrs.automated.expense.integration' }),
    paragraphs: [
      intl.formatMessage({ id: 'travel-mgrs.automated.expense.integration.p1' }),
      intl.formatMessage({ id: 'travel-mgrs.automated.expense.integration.p2' }),
    ],
  },
  {
    id: 'travel-mgrs.real-time-visibility',
    title: intl.formatMessage({ id: 'travel-mgrs.real.time.visibility' }),
    paragraphs: [
      intl.formatMessage({ id: 'travel-mgrs.real.time.visibility.p1' }),
      intl.formatMessage({ id: 'travel-mgrs.real.time.visibility.p2' }),
      intl.formatMessage({ id: 'travel-mgrs.real.time.visibility.p3' }),
    ],
  },
];


  return (
    <div className="weeks-results-page">
      <PageTemplate
        headerImage={HeaderImg}
        headerTitle={intl.formatMessage({ id: 'travel-mgrs.streamline.corporate.travel' })}
        headerSubtitle={intl.formatMessage({ id: 'travel-mgrs.streamline.corporate.travel.subtitle' })}
        tableOfContents={tocItems}
        contentSections={sections}
        positionHeaderImg='center'
      />
    </div>
  );
};

export default TravBusinessSolutionsTravelManagersPage;
